var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 100,
    viewBox: "0 0 72 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 13,
    fill: "#F3F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.096 93.33V92.16H13.822V87.3H20.122V86.112H12.526V99H13.822V93.33H19.096ZM23.3254 99V85.878H22.0834V99H23.3254ZM32.0869 90.288V94.914C32.0869 96.984 31.0969 98.1 29.4229 98.1C28.0369 98.1 27.1189 97.362 27.1189 95.292V90.27H25.8589V95.688C25.8589 97.812 26.9749 99.216 29.0269 99.216C30.3949 99.216 31.6009 98.532 32.0869 97.524L32.2489 99H33.3289V90.288H32.0869ZM37.9141 99V91.332H39.6601V90.288H37.9141V87.534H36.6901V90.288H34.9441V91.332H36.6901V99H37.9141ZM43.3458 99V91.332H45.0918V90.288H43.3458V87.534H42.1218V90.288H40.3758V91.332H42.1218V99H43.3458ZM50.2752 99.216C52.3272 99.216 53.6772 98.226 54.1452 96.39H52.9572C52.6332 97.542 51.7152 98.154 50.2932 98.154C48.4212 98.154 47.3052 96.93 47.2152 94.806H54.1452V94.194C54.1452 91.728 52.5432 90.054 50.1852 90.054C47.7012 90.054 46.0092 91.926 46.0092 94.644C46.0092 97.38 47.7192 99.216 50.2752 99.216ZM50.1852 91.116C51.8232 91.116 52.9032 92.232 52.9032 93.906H47.2512C47.4672 92.196 48.5472 91.116 50.1852 91.116ZM60.685 90.18C60.379 90.108 60.145 90.09 59.875 90.09C58.651 90.09 57.733 90.702 57.391 91.638L57.301 90.288H56.131V99H57.373V94.032C57.373 92.376 58.399 91.296 60.001 91.296H60.685V90.18Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4248 12L15.4023 36L22.8003 43.398L54.1683 12.024H39.4563L39.4248 12ZM39.4563 34.14L26.5098 47.0535L39.4563 60H54.1983L41.2758 47.0625L54.1983 34.14H39.4563Z",
    fill: "#2342E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/Flutter.046a23d9d06288d20b7290eacaefb10e.svg";
export { ForwardRef as ReactComponent };